export const SearchBarContainerDiv = ({ children }) => {
  return <div className='searchBarContainer'>{children}</div>;
};

export const SearchResultsContainerDiv = ({ children }) => {
  return <div id='searchResultsContainer'>{children}</div>;
};
